import { h } from "preact";

import i18n from "../../i18n.js";
import { getValue } from "../../helpers.js";

import Button from "../Button.jsx";
import HeaderIcon from "../HeaderIcon.jsx";
import Icon from "../Icon.jsx";
import List from "../List.jsx";
import ListItem from "../ListItem.jsx";
import UploadedListItem from "../UploadedListItem.jsx";
import Tag from "../Tag.jsx";
import WhitepaperTeaser from "../WhitepaperTeaser.jsx";

export default {
  statement_of_comparability: ({ answers, onNext, onRestart }) => {
    return (
      <section class="task-page">
        <HeaderIcon>comparability_procedure</HeaderIcon>
        <h1 class="task-page__headline">
          {i18n.t("pages.common.result_title")}
        </h1>

        <div class="task-page__content">
          <p>
            <Icon>check</Icon>
          </p>
          <List class="mb-32">
            <ListItem class="mb-32" overline="Statement of comparability">
              A statement of comparability from the German Central Office for
              Foreign Education (ZAB) is available.
            </ListItem>

            <UploadedListItem
              value={getValue(answers.outcomeStatementOfComparability)}
            />
          </List>
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.ok")}</Button>
          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },

  statement_of_comparability_start: ({ onNext }) => {
    return (
      <section class="task-page">
        <HeaderIcon>comparability_procedure</HeaderIcon>
        <h1 class="task-page__headline">Comparability procedure</h1>

        <div class="task-page__content">
          <p class="mb-48">
            The German Central Office for Foreign Education (ZAB) will issue
            your declaration of comparability.
          </p>
          <List class="mb-48">
            <ListItem number={1}>
              Fill out the application form here.
              <Tag
                class="ml-12"
                iconFront="language"
                to="https://anabin.kmk.org/antragsformular.html?L=1"
                target="_blank"
              >
                Anabin application
              </Tag>
            </ListItem>
            <ListItem number={2}>Print out the application form.</ListItem>
            <ListItem number={3}>Sign the application form.</ListItem>
            <ListItem number={4}>
              Compile the required documents here.
              <Tag
                class="ml-12"
                iconFront="language"
                to="https://www.kmk.org/zab/central-office-for-foreign-education/statement-of-comparability-for-foreign-higher-education-qualifications/documents-for-the-application.html"
                target="_blank"
              >
                ZAB documents
              </Tag>
            </ListItem>
            <ListItem number={5}>
              Send your application form along with the documents by post.
            </ListItem>
          </List>
          <p class="">
            <strong>Please note: </strong>Once the ZAB receives your complete
            application, they will provide details regarding payment. As soon as
            the ZAB has received your payment, it will start processing your
            declaration of comparability.
            <br />
            Did you receive your statement of comparability? Please pass this
            information on to Nioomi.
          </p>

          <WhitepaperTeaser
            class="mt-32"
            title="Qualification"
            description={i18n.t("whitepaperTeaser.qualification")}
            whitepaperId="degree-recognition-in-germany"
          />
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.enter_result")}</Button>
        </div>
      </section>
    );
  },
};
